// ./src/config/accountTypes.ts
//
// WHAT AN ACCOUNT RUNS (owner, 2026-10-14) — the choice offered on sign-up and in account settings, each with a short
// explanation. ms_auth stores only the word (`account.account_type`, any lowercase word — it checks the shape, never this
// list), so a type is added HERE without a deploy anywhere else. The app will use it to lead with what each kind of
// organizer needs first.
// ⚠ `value` is what is stored: never rename one (accounts already carry it) — add a new one, and keep the old value
//   readable (`accountTypeLabel` falls back to the raw word).

/** The account type that runs its own space — the venue steps (#161 d, the account onboarding) key off it. */
export const VENUE_ACCOUNT_TYPE = "venue";

export interface AccountTypeOption {
  value: string;
  label: string;
  /** One line under the label: who this is for. */
  description: string;
}

export const ACCOUNT_TYPES: readonly AccountTypeOption[] = [
  { value: "venue", label: "Venue, bar or restaurant", description: "You host events in your own space — live music, trivia, tastings, private parties." },
  { value: "event_planner", label: "Event planner or agency", description: "You plan and run events for clients." },
  { value: "nonprofit", label: "Nonprofit or charity", description: "Fundraisers, galas and community events, with volunteers and sponsors." },
  { value: "club", label: "Club or community group", description: "Members, meetings, socials and seasons." },
  { value: "sports", label: "Races and sports", description: "Races, rides, tournaments and leagues." },
  { value: "classes", label: "Classes, workshops or studio", description: "Courses, lessons and workshops with dates and limited seats." },
  { value: "festival", label: "Festival, market or fair", description: "Vendors, stages, maps and day tickets." },
  { value: "conference", label: "Meetups and conferences", description: "Talks, sessions, speakers and sponsors." },
  { value: "company", label: "Company or team", description: "Parties, offsites and team events for your own people." },
  { value: "other", label: "Something else", description: "Every feature is still there — tell us what you run any time." },
];

/** The label for a stored type — the raw word when this build does not know it (a newer type, or a retired one). */
export const accountTypeLabel = (value: string | null | undefined): string | null =>
  value ? (ACCOUNT_TYPES.find((t) => t.value === value)?.label ?? value) : null;
